"use strict";

exports.__esModule = true;
/* eslint arrow-parens: [0] */
var getModel = exports.getModel = function getModel(state) {
  return state.repository;
};

/**
 * getRepository()
 * usage:
 *  - selectors.getRepository('repositoryName')(reduxState)
 *  - selectors.getRepository('repositoryName').fromState(reduxState)
 */
var getRepository = exports.getRepository = function getRepository(repositoryName) {
  var fromState = function fromState(state) {
    return state.repository[repositoryName] && state.repository[repositoryName].value;
  };
  var ret = function ret(state) {
    return fromState(state);
  };
  ret.fromState = fromState;
  return ret;
};

/**
 * getPromise()
 * usage:
 *  - selectors.getPromise('repositoryName')(reduxState)
 *  - selectors.getPromise('repositoryName').fromState(reduxState)
 */
var getPromise = exports.getPromise = function getPromise(repositoryName) {
  var fromState = function fromState(state) {
    return state.repository[repositoryName];
  };
  var ret = function ret(state) {
    return fromState(state);
  };
  ret.fromState = fromState;
  return ret;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/reducers/selectors.js
// module id = 201
// module chunks = 0